export default __webpack_public_path__ + "static/media/construction-year.bb1f2533.jpg";